import React, { useEffect, useState } from "react"
import { Card, Col, Container, Form, Row } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Swal from "sweetalert2"
import axios from "axios"
import configure from "configure"
import Select from "react-select"
import {
  serviceOption,
  workOptionService,
} from "utils/common-options"
import Dropzone from "react-dropzone"
import { formatBytes } from "utils/common-helpers"
import { Switch } from "antd"
import { useSelector } from "react-redux"
import { fetchNodeData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"

const AddCaseStudy = () => {
  const navigate = useNavigate()

  const [fixButtons, setFixButtons] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const [ProjectName, setProjectName] = useState("")
  const [Service, setService] = useState("")
  const [Technology, setTechnology] = useState("")
  const [ProjectOverview, setProjectOverview] = useState("")
  const [Problem, setProblem] = useState("")
  const [Strategy, setStrategy] = useState("")
  const [Results, setResults] = useState([""])
  const [Testimonial, setTestimonial] = useState("")
  const [ProjectSImages, setSProjectImages] = useState([])
  const [ProjectImages, setProjectImages] = useState([])
  const [TestimonialImages, setTestimonialImages] = useState([])
  const [location, setlocation] = useState("")
  const [Website, setWebsite] = useState("")
  const [Ctype, setctype] = useState(false)
  const [Cemail, setcemail] = useState("")
  const [Cpassword, setCpassword] = useState("")
  const generalLocation = useSelector(state => state?.location?.locations)
  const [error, setError] = useState({})
  const [techOptions, setTechOption] = useState([])
  const [websiteLogo, setWebsiteLogo] = useState('')
  const [mainService, setMainService] = useState([])
  const addResultField = () => {
    setResults(prev => [...prev, ""])
  }

  // Update specific result by index
  const updateResult = (index, value) => {
    const updated = [...Results]
    updated[index] = value
    setResults(updated)
  }

  // Remove specific result input
  const removeResultField = index => {
    const updated = Results.filter((_, i) => i !== index)
    setResults(updated)
  }

  const saveCaseStudy = async e => {
    e.preventDefault()
    const validationErrors = {}
    if (!ProjectName.trim())
      validationErrors.ProjectName = "Project Name is required"
    if (!Website.trim()) validationErrors.Website = "Website URL is required"
    if (!location.value) validationErrors.location = "Location is required"
    if (!Service.value) validationErrors.Service = "Service is required"
    if (Technology?.length == 0)
      validationErrors.Technology = "Technology is required"
    if (!ProjectOverview.trim())
      validationErrors.ProjectOverview = "Project Overview is required"
    if (!Problem.trim()) validationErrors.Problem = "Problem is required"
    if (!Strategy.trim()) validationErrors.Strategy = "Strategy is required"
    if (!Results.length || Results.some(r => !r.trim()))
      validationErrors.Results = "All Achieved Results must be filled"
    // if (!Testimonial.trim())
    //   validationErrors.Testimonial = "Testimonial is required"

    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors)
      return
    }

    setError({})
    setLoading(true)

    const formdata = new FormData()
    formdata.append("added_by", localStorage.getItem('auth_id'))
    formdata.append("location", location.value)
    formdata.append("website", Website)
    formdata.append("project_name", ProjectName)
    formdata.append("services", Service.value)
    formdata.append("technology", Technology?.map((obj) => obj?.value))
    formdata.append("project_overview", ProjectOverview)
    formdata.append("problem_information", Problem)
    formdata.append("strategy_and_approach", Strategy)
    formdata.append("achieved_results", JSON.stringify(Results))
    formdata.append("testimonial", Testimonial)
    formdata.append("websiteLogo", websiteLogo)
    ProjectSImages.forEach(file => {
      formdata.append("project_image", file)
    })

    TestimonialImages.forEach(file => {
      formdata.append("testimonial_image", file)
    })
    if (Ctype) {
      formdata.append("credential_email", Cemail)
      formdata.append("credential_password", Cpassword)
    }

    try {
      const res = await axios.post(`${configure.nodeApi}/case-study`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      if (res?.data?.success) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Case Study saved successfully!",
          confirmButtonColor: "#556ee6",
        }).then(() => {
          navigate(`${configure.appUrl}case-study`)
        })
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something Went Wrong",
      })
    }
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  function handleAcceptedFiles1(files) {
    const updatedFiles = files.map(file => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }))

    setSProjectImages(prevFiles => [...prevFiles, ...files])
    setProjectImages(prevFiles => [...prevFiles, ...updatedFiles])
  }
  
  const toggleLoading = (loading) => {
    setLoading(loading);
  }

  useEffect(() => {
    const onGetTechnologies = async () => {
      const res = await fetchNodeData(toggleLoading, 'portfolio-technologies');
      if (res?.success) {
        setTechOption(res?.data?.map((obj) => ({
          value: obj?.id,
          label: obj?.name
        })))
      }
    }
    onGetTechnologies()
  }, [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-3">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Add Case Study"} />
          <Row className="px-1">
            <Form onSubmit={saveCaseStudy}>
              <div
                className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  type="submit"
                  className="btn btn-save fix-btn btn-label pe-0"
                >
                  <i className="fas fa-save me-2 label-icon"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red  fix-btn  btn-label pe-0"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  <span>Cancel</span>
                </a>
              </div>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-6 mb-3">
                  <h5 className="mb-3">Case Study Information</h5>
                </div>
                <div className="col-md-6 mb-3 text-end">
                  <button
                    type="submit"
                    onClick={e => saveCaseStudy(e)}
                    className=" btn ms-md-2 btn-save  btn-label"
                  >
                    <i className="fas fa-save me-1 label-icon"></i> save
                  </button>
                  <a
                    onClick={e => {
                      navigate(-1)
                    }}
                    className=" btn ms-md-2 btn-red  btn-label "
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </a>
                </div>
                <div className="row">
                  <div className="col-md-2 mb-3">
                    <label>
                      Location <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Location"
                      value={location}
                      onChange={e => setlocation(e)}
                      options={generalLocation}
                    ></Select>
                    {error.location && (
                      <span className="text-danger">{error.location}</span>
                    )}
                  </div>
                  <div className="col-md-2">
                    <label>Filter by Service</label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Service"
                      options={workOptionService}
                      onChange={(e) => setMainService(e)}
                    ></Select>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Services <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Services"
                      value={Service}
                      onChange={e => setService(e)}
                      options={serviceOption?.filter((obj) => obj?.sub == mainService?.value)}
                    ></Select>
                    {error.Service && (
                      <span className="text-danger">{error.Service}</span>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Technology <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Technology"
                      isMulti
                      value={Technology}
                      onChange={e => setTechnology(e)}
                      options={techOptions}
                    ></Select>
                    {error.Technology && (
                      <span className="text-danger">{error.Technology}</span>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Project Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter Project Name"
                      value={ProjectName}
                      onChange={e => setProjectName(e.target.value)}
                    />
                    {error.ProjectName && (
                      <span className="text-danger">{error.ProjectName}</span>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Website <span className="text-danger">*</span>
                    </label>
                    <input
                      value={Website}
                      onChange={e => setWebsite(e.target.value)}
                      type="text"
                      className="form-control"
                      placeholder="Enter Website"
                    ></input>
                    {error.Website && (
                      <span className="text-danger">{error.Website}</span>
                    )}
                  </div>

                  {/* <div className="col-xl-4"></div> */}

                  <div className="col-md-4 mb-3">
                    <label>
                      Credentials <span className="text-danger">*</span>
                    </label>
                    <div>
                      <Switch
                        defaultChecked={Ctype}
                        className="mt-1"
                        style={{ fontSize: "14px" }}
                        onChange={e => {
                          console.log(e), setctype(e)
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-4 mb-3">
                    <label>Website Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={e => setWebsiteLogo(e.target.files[0])}
                    />
                  </div>

                  {Ctype && (
                    <>
                      <div className="col-md-4 mb-3">
                        <label>
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          placeholder="Enter Credential Email"
                          value={Cemail}
                          onChange={e => setcemail(e.target.value)}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <label>
                          Password <span className="text-danger">*</span>
                        </label>
                        <input
                          value={Cpassword}
                          onChange={e => setCpassword(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="Enter Credential Password"
                        ></input>
                      </div>
                    </>
                  )}
                </div>
              </Row>

              {/* Project Overview */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Project Overview</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={ProjectOverview}
                    onChange={(event, editor) => {
                      setProjectOverview(editor.getData())
                    }}
                  />
                  {error.ProjectOverview && (
                    <span className="text-danger">{error.ProjectOverview}</span>
                  )}
                </div>
                <div className="col-6 mb-3">
                  <label>Project Images</label>
                  <Dropzone
                    onDrop={acceptedFiles => {
                      console.log(acceptedFiles)
                      handleAcceptedFiles1(acceptedFiles)
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="dz-message needsclick p-0"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div
                          className="d-flex px-2 custom-file-upload align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="">
                            <i className="display-6 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h5 className="mb-0 ms-2">Upload Files</h5>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
                <div
                  className={`mt-3 col-6 dropzone-previews ${ProjectImages.length > 0 ? "d-block" : "d-none"
                    }`}
                  id="file-previews"
                >
                  <label className="mb-1">Uploaded Files</label>
                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                    <div className="p-0">
                      <Row className="align-items-center justify-content-evenly">
                        {ProjectSImages?.map((f, i) => {
                          return (
                            <Col key={i} className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                          )
                        })}
                      </Row>
                    </div>
                  </Card>
                </div>
              </Row>

              {/* Problem */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Problem Information</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Problem}
                    onChange={(event, editor) => {
                      setProblem(editor.getData())
                    }}
                  />
                  {error.Problem && (
                    <span className="text-danger">{error.Problem}</span>
                  )}
                </div>
              </Row>

              {/* Strategy */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Strategy & Approach</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Strategy}
                    onChange={(event, editor) => {
                      setStrategy(editor.getData())
                    }}
                  />
                  {error.Strategy && (
                    <span className="text-danger">{error.Strategy}</span>
                  )}
                </div>
              </Row>

              {/* Results */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4 d-flex justify-content-between align-items-center">
                  Achieved Results
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={addResultField}
                  >
                    + Add Result
                  </button>
                </h5>
                <div className="col-12">
                  {Results.map((result, index) => (
                    <div key={index} className="d-flex mb-2 align-items-center">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder={`Result #${index + 1}`}
                        value={result}
                        onChange={e => updateResult(index, e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeResultField(index)}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {error.Results && (
                    <span className="text-danger">{error.Results}</span>
                  )}
                </div>
              </Row>

              {/* Testimonial */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Testimonial</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Testimonial}
                    onChange={(event, editor) => {
                      setTestimonial(editor.getData())
                    }}
                  />
                  {error.Testimonial && (
                    <span className="text-danger">{error.Testimonial}</span>
                  )}
                </div>
                <div className="col-12 mb-3">
                  <label>Testimonial Images</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={e => setTestimonialImages(Array.from(e.target.files))}
                    multiple
                  />
                </div>
              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddCaseStudy
